import { useDispatch } from 'react-redux';
import { Grid, Stack, Typography } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import { PublicationSelector } from './PublicationSelector';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreativeTagState, PlayerState, PlaylistAPIData } from './types/playlist';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from './common/Link';

const BreadCrumbLink = styled(Link)`
    cursor: pointer;
`;

const BreadCrumb = styled(Typography)`
  color: black;
  font-family: 'ProximaNovaLight';
  font-size: 14px;
  text-decoration: none;
`
const IABList = styled('h2')`
    margin: 0;
    font-weight: bold;
`;
type ToolBarPlaylistProps = {
  playlist?: PlaylistAPIData,
  creative?: PlayerState
  tag?: CreativeTagState
}

function ToolBarPlaylist({
  playlist,
  creative,
  tag
}: ToolBarPlaylistProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: 'SET_FILTER_FORMAT', payload: 'vertical' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const breadcrumbs = [
    <BreadCrumbLink onClick={() => navigate('/playlist')}>
      Playlists
    </BreadCrumbLink>,
  ];

  if (playlist) {
    if (creative) {
      breadcrumbs.push(<BreadCrumbLink
        onClick={() => navigate(`/playlist/creative/${playlist?.uuid}`)}>
        {playlist.name}
      </BreadCrumbLink>);
    } else {
      breadcrumbs.push(<BreadCrumb>{playlist.name}</BreadCrumb>);
    }
  }

  if (creative) {
    if (tag) {
      breadcrumbs.push(<BreadCrumbLink
        onClick={() => navigate(`/playlist/creative/${playlist?.uuid}/${creative.id}/tags`)}>
        {creative.name}
      </BreadCrumbLink>);
    } else {
      breadcrumbs.push(<BreadCrumb>{creative.name}</BreadCrumb>)
    }
  }


  if (tag) {
    breadcrumbs.push(<BreadCrumb>
      {tag.name}
    </BreadCrumb>);
  }

  return (
    <Toolbar style={{
      paddingBottom: '45px',
      paddingLeft: '15px',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }}>
      <Grid container alignItems="center" justifyContent={playlist ? 'space-between' : 'flex-end'}>
        {playlist && <>
          <Grid item>
            <Stack spacing={2}>
              <Breadcrumbs separator="›" aria-label="breadcrumb">
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
          </Grid>
        </>}
        <PublicationSelector/>
      </Grid>

      {playlist && playlist.playlist_type_id === 1 && playlist.iab_categories.length > 0 && <Box>
        {!playlist.iab_categories_exclude &&
          <IABList>{playlist.iab_categories.join(', ')}</IABList>}
      </Box>}
    </Toolbar>
  );
}

export default styled(ToolBarPlaylist)`
    margin-bottom: 40px;
`;
